// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c99d326c","239":"5ab85b35","453":"8416de6a","732":"651afd20"}[chunkId] + ".chunk.js";
};